import React, { useState } from 'react';
import {
	Button,
	ListItem,
	List,
	ListItemText,
	ListItemIcon,
	Collapse,
	Icon
} from '@material-ui/core';
import {
	ExpandLess,
	ExpandMore
} from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';

import DropdownMenu from './DropdownMenu';

export default function HeaderMenu(props) {
	const [open, setOpen] = useState(null);
	const theme = useTheme();

	const handleClick = (index) => {
		open && open[index]
			? setOpen((prevState) => ({
				...prevState,
				[index]: !open[index]
			}))
			: setOpen((prevState) => ({
				...prevState,
				[index]: true
			}));
	};

	const mobileMenu = (
		<List>
			{props.menu
				? props.menu.map((item, index) => (item.submenu.length
					? (
						<>
							<ListItem key={item.id} button onClick={() => handleClick(index)}>
								<ListItemIcon>
									<Icon style={{ color: theme.palette.primary.main, fontSize: '25px' }}>{item.icon}</Icon>
								</ListItemIcon>
								<ListItemText primary={item.label} />
								{open && open[index] ? <ExpandLess /> : <ExpandMore />}
							</ListItem>
							<Collapse in={Boolean(open && open[index])} timeout="auto" unmountOnExit>
								<List component="div" disablePadding style={{ paddingLeft: '15px' }}>
									{item.submenu.map((item) => (
										<ListItem key={item.id} button onClick={() => { window.location = item.url; }}>
											<ListItemIcon>
												<Icon style={{ color: theme.palette.primary.main, fontSize: '25px' }}>{item.icon}</Icon>
											</ListItemIcon>
											<ListItemText primary={item.label} />
										</ListItem>
									))}
								</List>
							</Collapse>
						</>
					)
					: (
						<ListItem key={item.id} button onClick={() => { window.location = item.url; }}>
							<ListItemIcon>
								<Icon style={{ color: theme.palette.primary.main, fontSize: '25px' }}>{item.icon}</Icon>
							</ListItemIcon>
							<ListItemText primary={item.label} />
						</ListItem>
					)))
				: null}
		</List>
	);

	const desktopMenu = (
		props.menu
			? props.menu.map((item) => (item.submenu.length
				? <DropdownMenu key={item.id} item={item} />
				: <Button key={item.id} onClick={() => { window.location = item.url; }} style={{ outline: 0 }}>{item.label}</Button>))
			: null
	);

	return (
		props.mobileView ? mobileMenu : desktopMenu
	);
}
